import { render, staticRenderFns } from "./AgencyCommerceCardComponent.vue?vue&type=template&id=a0bb15a2"
import script from "./AgencyCommerceCardComponent.vue?vue&type=script&lang=js"
export * from "./AgencyCommerceCardComponent.vue?vue&type=script&lang=js"
import style0 from "./AgencyCommerceCardComponent.vue?vue&type=style&index=0&id=a0bb15a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports